// Recovered compiled webpack factory 42444. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      default: function () {
        return a;
      },
      getProperError: function () {
        return o;
      },
    }));
  let n = r(16486);
  function a(e) {
    return "object" == typeof e && null !== e && "name" in e && "message" in e;
  }
  function o(e) {
    return a(e)
      ? e
      : Object.defineProperty(
          Error(
            (0, n.isPlainObject)(e)
              ? (function (e) {
                  let t = new WeakSet();
                  return JSON.stringify(e, (e, r) => {
                    if ("object" == typeof r && null !== r) {
                      if (t.has(r)) return "[Circular]";
                      t.add(r);
                    }
                    return r;
                  });
                })(e)
              : e + "",
          ),
          "__NEXT_ERROR_CODE",
          { value: "E394", enumerable: !1, configurable: !0 },
        );
  }
}
